import { useEffect, useState } from 'react'
import { Card, CardBody, Col, Toast, ToastBody } from 'reactstrap'
import { ColorsScheme } from '../../../../utils/Constant'
import { colorSchema } from '../../../../Data/BonusUi/Toast/Toast'
import { Btn } from '../../../../AbstractElements'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const ColorsSchemes = () => {
  const [open,setOpen] = useState<boolean>(true)
  useEffect(() => {
    setTimeout(()=>{
      setOpen(false)
    },5000)
  },[])
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={ColorsScheme} span={colorSchema} />
        <CardBody className="toast-rtl">
          <Toast fade className="default-show-toast align-items-center text-light bg-warning border-0" isOpen={open}>
            <div className="d-flex align-items-center justify-content-between">
              <ToastBody>Your time over after 5 minute.</ToastBody>
              <Btn close className="btn-close-white me-2 m-auto" onClick={() => setOpen(false)}></Btn>
            </div>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ColorsSchemes